/* styled-compiled.tsx generated by @compiled/babel-plugin v0.36.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isSelected", "children"];
import "./styled-compiled.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { B300, N30A, N40A, N900 } from '@atlaskit/theme/colors';
var selectedStyles = null;
var notSelectedStyles = null;
var wrapperStyles = null;

/*
  Media Inline cards should have the following layout:
  -----------------
  | icon | title |
  -----------------
  The aim is to ensure (1) all children are
  in line with each other, (2) are vertically
  centered.
*/
// NB: `padding` consistent with @mentions.
// NB: `display: inline` required for `box-decoration-break` to work.
// NB: `box-decoration-break` required for retaining properties (border-radius) on wrap.
export var Wrapper = function Wrapper(_ref) {
  var isSelected = _ref.isSelected,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", _extends({
    "data-testid": "frame-wrapper"
  }, props, {
    className: ax(["_2rko1sit _v56415x0 _vwz47vkz _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _16d9qvcn _1e0c1nu9 _syazovqm _bfhkfpvg _1rkwglyw _80omtlke _irr3l5fl", isSelected && "_12ji1r31 _1qu2glyw _12y31o36 _1h6d1j28 _80omtlke _16qs1qst _uiztglyw _4bfu1r31 _1nrm1r31 _1a3b1r31 _9oik1r31 _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1", !isSelected && "_uizt1kdv"]),
    style: {
      "--_5xk3r4": ix("var(--ds-text, ".concat(N900, ")")),
      "--_9tzd1j": ix("var(--ds-background-neutral, ".concat(N30A, ")")),
      "--_138ec4y": ix("var(--ds-background-neutral-hovered, ".concat(N40A, ")")),
      "--_7nesqg": ix("0 0 0 1px ".concat("var(--ds-border-selected, ".concat(B300, ")")))
    }
  }), children);
};